import { nanoid } from "nanoid";
import { useMemo } from "react";

function createElementFocus() {
  let currentAnimation = null;
  let elToFocus = null;

  const addFocusElement = (el) => {
    if (elToFocus) {
      // eslint-disable-next-line no-console
      console.warn("DEV: Can't focus multiple elements!");
      return;
    }
    elToFocus = el;
  };

  const focusAfterNavigation = (e, key) => {
    if (key !== currentAnimation) return;
    if (e !== "animate") return;

    if (elToFocus) {
      elToFocus.focus();
      elToFocus = null;
    } else {
      document.querySelector(".chakra-modal__content")?.focus();
    }
    currentAnimation = null;
  };

  const beforeNavigation = (e, key) => {
    currentAnimation = key;
  };

  return {
    addElement: addFocusElement,
    afterNavigation: focusAfterNavigation,
    beforeNavigation
  };
}

export const Focus = createElementFocus();

export function useFocus() {
  return useMemo(() => {
    const id = nanoid();
    return {
      beforeNavigation(event) {
        Focus.beforeNavigation(event, id);
      },
      afterNavigation(event) {
        Focus.afterNavigation(event, id);
      }
    };
  }, []);
}

export function withFocus(Component) {
  return (props) => {
    const focus = useFocus();
    return <Component focus={focus} {...props} />;
  };
}
